import angular from 'angular';

import { applySessionData } from 'auth/actions/session.actions';
import utilsApi from 'utils/resources/utils.api';
import { fetchLinkedRetailers } from 'user/resources/linked-retailers.api';

import { RETAILER_TYPE } from 'app/validators/roles';
import template from './rw-location-selector.html';

const mapStateToThis = ({ session, config }) => {
  const { defaultPageSizes } = config;
  const { retailers, retailer, id, retailersIds } = session;

  return {
    retailers,
    retailer,
    defaultPageSizes,
    id,
    retailersIds,
  };
};

const mapDispatchToThis = {
  applySessionData,
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux', 'Notifications', '$state', '$document')
class RwLocationSelectorController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  $onInit() {
    // eslint-disable-next-line prefer-destructuring
    this.threshold = this.defaultPageSizes[1];
    this.sortProperty = 'displayOrder';
    // eslint-disable-next-line prefer-destructuring
    this.appendToElement = angular.element(this.$document[0].querySelectorAll('#side-menu-header-selector'))[0];

    this.fetchLocations();
  }

  showMoreLocations() {
    return !(
      !this.locations ||
      this.locations.length === 0 ||
      (this.locations.length === 1 && this.locations[0].displayNumber === this.retailer.retailerDisplayNumber)
    );
  }

  async fetchLocations() {
    const { content, totalElements } = await fetchLinkedRetailers({
      directAssignment: true,
      pageSize: this.threshold,
      sortProperty: this.sortProperty,
      isLinkedRetailers: true
    });

    this.locations = content.map(({ address, retailerName, zip, retailerDisplayNumber, ...location }) => ({
      ...location,
      street1: address,
      businessName: retailerName,
      zipCode: zip,
      displayNumber: retailerDisplayNumber,
    }));

    this.showDropdown = totalElements <= this.threshold;
  }

  $onDestroy() {
    this.unsubscribe();
  }

  async onOpenDialog() {
    const selectedRetailer = await this.Notifications.showComplexDialog({
      component: 'rwLocationSelectorDialog',
    }).result;

    if (selectedRetailer) {
      this.onLocationChange({
        displayNumber: selectedRetailer.retailerDisplayNumber,
      });
    }
  }

  findSelectedRetailer(displayNumber) {
    return this.retailers.find(({ retailerDisplayNumber }) => retailerDisplayNumber === displayNumber);
  }

  async onLocationChange({ displayNumber }) {
    const isAlreadyLoggedIn = displayNumber === this.retailer.retailerDisplayNumber;

    if (isAlreadyLoggedIn) return;

    let retailer = this.findSelectedRetailer(displayNumber);
    retailer = Object.assign(retailer, {
      isChain: retailer.retailerType ? retailer.retailerType.indexOf(RETAILER_TYPE.CHAIN_SUFFIX) !== -1 : false,
      isChainHead: retailer.retailerType ? retailer.retailerType === RETAILER_TYPE.CHAIN_HEAD : false,
      isChainSubordinate: retailer.retailerType ? retailer.retailerType === RETAILER_TYPE.CHAIN_SUBORDINATE : false,
      isSuperChain: retailer.retailerType ? retailer.retailerType === RETAILER_TYPE.SUPER_CHAIN : false,
      isIndependent: retailer.retailerType ? retailer.retailerType === RETAILER_TYPE.INDEPENDENT : false,
    });

    await utilsApi.changeLocation(displayNumber, this.id);

    await this.applySessionData({
      retailer,
      retailersIds: this.retailersIds,
    });

    this.$state.go('dashboard-summary', null, {
      reload: true,
    });
  }
}

export default class RwLocationSelectorComponent {
  constructor() {
    this.template = template;
    this.controller = RwLocationSelectorController;
  }
}



// WEBPACK FOOTER //
// ./src/modules/utils/rw-location-selector/rw-location-selector-component.js